module.exports = __webpack_public_path__ + "assets/img/partners5.6c009ca1.jpg";